<div class="card flex flex-col gap-3 p-4" [attr.data-testid]="testId()">
  <span class="text-muted-color text-sm">{{ titleKey() | transloco }}</span>
  <span class="text-3xl font-bold text-white" [attr.data-testid]="testId() + '-total'">
    {{ split().total | appNumber: digitsInfo() }}
  </span>
  <div class="grid grid-cols-2 gap-3">
    <div class="bg-third-level flex flex-col gap-1 rounded-lg p-3">
      <span class="text-sm">
        {{ 'project.steps.companyInfo.categorySalaried' | transloco }}
      </span>
      <span class="font-semibold text-white" [attr.data-testid]="testId() + '-salaried'">
        {{ split().salaried | appNumber: digitsInfo() }}
      </span>
    </div>
    <div class="bg-third-level flex flex-col gap-1 rounded-lg p-3">
      <span class="text-sm">
        {{ 'project.steps.companyInfo.categoryIndustrial' | transloco }}
      </span>
      <span class="font-semibold text-white" [attr.data-testid]="testId() + '-industrial'">
        {{ split().industrial | appNumber: digitsInfo() }}
      </span>
    </div>
  </div>
</div>
